enum CREDIT_FACTOR {
  AGE_AND_MIX_OF_ACCOUNTS = 'ageAndMixOfAccounts',
  BALANCES = 'balances',
  CREDIT_UTILIZATION = 'creditUtilization',
  PAYMENT_HISTORY = 'paymentHistory',
  RECENT_INQUIRIES = 'recentInquiries',
}

export const CREDIT_FACTOR_ORDER = [
  CREDIT_FACTOR.PAYMENT_HISTORY,
  CREDIT_FACTOR.CREDIT_UTILIZATION,
  CREDIT_FACTOR.AGE_AND_MIX_OF_ACCOUNTS,
  CREDIT_FACTOR.BALANCES,
  CREDIT_FACTOR.RECENT_INQUIRIES,
];

interface CreditFactorConfig {
  displayName: string;
  impactLevel: string;
  segmentEventPrefix: string;
}

export const creditFactorConfig: Record<CREDIT_FACTOR, CreditFactorConfig> = {
  [CREDIT_FACTOR.AGE_AND_MIX_OF_ACCOUNTS]: {
    displayName: 'Age & mix of accounts',
    impactLevel: 'Medium impact',
    segmentEventPrefix: 'Age And Mix',
  },
  [CREDIT_FACTOR.BALANCES]: {
    displayName: 'Balances',
    impactLevel: 'Medium impact',
    segmentEventPrefix: 'Credit Balance',
  },
  [CREDIT_FACTOR.CREDIT_UTILIZATION]: {
    displayName: 'Credit utilization',
    impactLevel: 'High impact',
    segmentEventPrefix: 'Credit Utilization',
  },
  [CREDIT_FACTOR.PAYMENT_HISTORY]: {
    displayName: 'Payment history',
    impactLevel: 'Highest impact',
    segmentEventPrefix: 'Payment History',
  },
  [CREDIT_FACTOR.RECENT_INQUIRIES]: {
    displayName: 'Recent inquiries',
    impactLevel: 'Low impact',
    segmentEventPrefix: 'Recent Inquiry',
  },
};
